export const CHECKOUT_URL =
  'https://mega-pack-educacion-agropecuaria-en-el-aula.impultienda.ar/checkout'

export function trackInitiateCheckout() {
  if (typeof window === 'undefined') return
  const w = window as unknown as { fbq?: (...args: unknown[]) => void }
  if (w.fbq) {
    w.fbq('track', 'InitiateCheckout', {
      content_name: 'Mega Pack Educación Agropecuaria en el Aula',
      value: 19.9,
      currency: 'USD',
    })
  }
}
